<template>
  <div class="background-display">
  <v-container fluid class="px-1">
    <Navbar />
      <v-container>
      <v-card>
        <v-toolbar dark color="#00b2bb">
          <h2 class="ma-5 headline font-weight-thin">{{ titulo }}</h2>
        </v-toolbar>
        <v-card-text>
          <v-alert v-model="alertAxios" border="left" close-text="Close Alert" dismissible dense outlined type="error">
              Ha ocurrido un error!
          </v-alert>
          <v-alert v-if="$route.query.fail" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Transacción Fallida. Por favor intente de nuevo.
          </v-alert>
          <v-container>
            <v-divider></v-divider>
            <v-col class="my-5 text-center">
            <h2>VALERIA DEL CARMEN RONCHERA FLORES</h2>
            <h4>10° NOTARÍA DE SANTIAGO</h4>
            <h4>R.U.T.: 9.493.719-1 </h4>
            <h4>Agustinas 1235 Piso 1 y 2 - Santiago</h4>
            <h4>Fonos: 22 865 0420/421 - 422 - 423 - 424</h4>
            <h4>Email: info@notariaronchera.cl - www.notariaronchera.cl</h4>
            </v-col>
            <v-divider></v-divider>
            <v-row>
              <v-col xs="6" md="4" v-if="documento.numeroBoleta">
                <h4 class="font-weight-regular black--text ml-5">Nº Boleta</h4>
                <v-text-field
                  flat
                  class="ml-2"
                  solo
                  disabled
                  v-model= documento.numeroBoleta
                ></v-text-field>
              </v-col>
              <v-col xs="6" md="4" sm="4"
              offset-md="4" class="pr-1">
                <h4 class="font-weight-regular black--text ml-5">Fecha</h4>
                <v-text-field
                  flat
                  class="ml-1"
                  :value = "displayValue(documento.fecha)"
                  solo
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12">
                <h4 class="font-weight-regular black--text ml-5">Trámite</h4>
                <h3 class="font-weight-regular ml-5 mt-3 mb-5" disabled v-text="documento.nombreTramite"></h3>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="12" xs="12" md="4"
              offset-md="4" lg="4" sm="6">
                <h4 class="font-weight-regular black--text ml-5">Costo Servicio Firma Electronica TOC</h4>
                <v-text-field
                  label="TOC"
                  flat
                  class="ml-2"
                  solo
                  width="50px"
                  prepend-inner-icon="mdi-currency-usd"
                  disabled
                  v-model= documento.precioToc
                  ></v-text-field>
                <h4 class="font-weight-regular black--text ml-5">Costo Notaria</h4>
                <v-text-field
                  label="Notaria"
                  solo
                  class="ml-2"
                  flat
                  width="50px"
                  prepend-inner-icon="mdi-currency-usd"
                  disabled
                  v-model= documento.precioTramite
                  ></v-text-field>
                <h4 class="font-weight-regular black--text ml-5">Costo Total</h4>
                <v-text-field
                  label="Total"
                  solo
                  class="ml-2"
                  flat
                  width="50px"
                  prepend-inner-icon="mdi-currency-usd"
                  disabled
                  v-model= documento.precioTotal
                  ></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <template>
              <v-row cols="12" xs="6" md="4" lg="4" class="mx-2">
                <template >
                  <v-spacer></v-spacer>
                  <v-btn color="#00b2bb" dark :to="'/mydocument/documentlist'" style="margin-top: 40px;"
                  >Continuar</v-btn>
                </template>
              </v-row>
              </template>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      </v-container>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
  </v-container>
  </div>
</template>
<style>
.title-size {
  font-size: 1.25em;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
.button-position {
  margin-bottom: 35px;
}
</style>
<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import api from '@/plugins/api'
import moment from '@/plugins/moment'
/* import textAreaField from '../../components/fields/textArea/Field.vue' */
/* import cost1 from '@/mock/cost1.json' */

export default {
  name: 'StatusDocument',
  components: {
    Navbar
    /* textAreaField */
  },
  data () {
    return {
      titulo: 'Boleta de Trámite',
      dialog: false,
      overlay: false,
      alertAxios: false,
      id: this.$route.params.id,
      documento: []
    }
  },
  mounted () {
    this.getTodos(this.$route.params.id)
    this.overlay = !this.overlay
  },
  /* watch: {
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 4000)
    }
  }, */
  methods: {
    async getTodos (id) {
      try {
        const response = await api.get(`mis-tramites/${id}`)
        this.documento = response.data
        this.overlay = false
        /* console.log(this.documento) */
      } catch (error) {
        this.alertAxios = true
        this.overlay = false
        console.log('Get error ' + error)
      }
    },
    displayValue (value) {
      return value ? moment(value).format('DD-MM-YYYY') : ''
    }
  }
}
</script>
